"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryLinksWrapper = exports.Input = exports.ControlNav = exports.Actions = exports.Line = exports.MobileSubLinks = exports.StyledExpander = exports.ModalContainer = exports.ModalContent = exports.ControlButton = exports.ModalControl = exports.LogoWrapper = exports.SubNavItem = exports.NavItem = exports.Wrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _expander = _interopRequireDefault(require("@berlitz/expander"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileNavstyle__Wrapper",
  componentId: "sc-1pplbpw-0"
})(["display:flex;justify-content:space-between;position:fixed;left:0;right:0;top:0;z-index:1;@media (min-width:", "){display:none;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.md;
});
exports.Wrapper = Wrapper;
var navItemStyle = (0, _styledComponents.css)(["display:flex;color:", ";font-size:", ";font-weight:", ";text-decoration:none;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.topNav.mobile.navItemColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.topNav.mobile.navItemFontSize;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.topNav.mobile.navItemFontWeight;
});
var navItemPadding = (0, _styledComponents.css)(["padding:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.topNav.mobile.navItemPadding;
});
var NavItem = _styledComponents.default.li.withConfig({
  displayName: "MobileNavstyle__NavItem",
  componentId: "sc-1pplbpw-1"
})(["a{", ";", ";}"], navItemStyle, navItemPadding);
exports.NavItem = NavItem;
var SubNavItem = _styledComponents.default.li.withConfig({
  displayName: "MobileNavstyle__SubNavItem",
  componentId: "sc-1pplbpw-2"
})(["a,button{", ";font-size:", ";font-weight:", ";", " padding:", ";border-bottom:1px solid ", ";}button{cursor:pointer;width:100%;}"], navItemStyle, function (_ref6) {
  var theme = _ref6.theme;
  return theme.topNav.mobile.subItemFontSize;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.topNav.mobile.subItemFontWeight;
}, (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      padding-left: ", ";\n    "])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.topNav.mobile.subItemIndentLeft;
}), function (_ref9) {
  var theme = _ref9.theme;
  return "".concat(theme.space.md, " ").concat(theme.space.lg);
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.ui02;
});
exports.SubNavItem = SubNavItem;
var LogoWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileNavstyle__LogoWrapper",
  componentId: "sc-1pplbpw-3"
})(["", " span{align-items:center;}"], (0, _styledComponentsRtl.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-left: ", ";\n  "])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.xxs;
}));
exports.LogoWrapper = LogoWrapper;
var ModalControl = _styledComponents.default.div.withConfig({
  displayName: "MobileNavstyle__ModalControl",
  componentId: "sc-1pplbpw-4"
})(["width:100%;display:flex;justify-content:space-between;align-items:center;box-shadow:", ";background-color:", ";height:", ";", " z-index:15;@media (min-width:", "){", "}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.topNav.mobile.boxShadow;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.ui00;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.topNav.mobile.barHeight;
}, (0, _styledComponentsRtl.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-left: ", ";\n  "])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.md;
}), function (_ref16) {
  var theme = _ref16.theme;
  return theme.breakpoints.sm;
}, (0, _styledComponentsRtl.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      padding-left: ", ";\n    "])), function (_ref17) {
  var theme = _ref17.theme;
  return theme.space.md;
}));
exports.ModalControl = ModalControl;
var ControlButton = _styledComponents.default.button.withConfig({
  displayName: "MobileNavstyle__ControlButton",
  componentId: "sc-1pplbpw-5"
})(["padding:", ";", " outline:none;cursor:pointer;"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.space.md;
}, (0, _styledComponentsRtl.default)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    margin-right: ", ";\n  "])), function (_ref19) {
  var theme = _ref19.theme;
  return theme.space.md;
}));
exports.ControlButton = ControlButton;
var ModalContent = _styledComponents.default.ul.withConfig({
  displayName: "MobileNavstyle__ModalContent",
  componentId: "sc-1pplbpw-6"
})(["padding-top:", ";max-width:100%;max-height:100%;overflow-y:auto;height:100vh;-webkit-overflow-scrolling:touch;margin-top:", ";padding-bottom:50vh;"], function (_ref20) {
  var theme = _ref20.theme;
  return theme.space.xs;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.topNav.mobile.barHeight;
});
exports.ModalContent = ModalContent;
var ModalContainer = _styledComponents.default.div.withConfig({
  displayName: "MobileNavstyle__ModalContainer",
  componentId: "sc-1pplbpw-7"
})(["background-color:", ";position:fixed;box-shadow:", ";top:0;", " width:100%;height:100%;overflow-y:hidden;z-index:-1;transition-property:all;transition-timing-function:", ";transition-duration:", "ms;transform:", ";will-change:transform;box-shadow:", ";"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.topNav.mobile.menuBackgroundColor || '#fff';
}, function (_ref23) {
  var open = _ref23.open,
    theme = _ref23.theme;
  return open ? theme.topNav.mobile.boxShadow : 'none';
}, (0, _styledComponentsRtl.default)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    left: 0;\n  "]))), function (_ref24) {
  var theme = _ref24.theme;
  return theme.animation.cubicBezier.fastOutSlowIn;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.topNav.mobile.toggleDuration;
}, function (_ref26) {
  var open = _ref26.open,
    topNav = _ref26.theme.topNav;
  return open ? (0, _styledComponents.css)(["translate", "(0%);visibility:visible;"], topNav.mobile.animationAxis) : (0, _styledComponents.css)(["translate", "(-100%);visibility:hidden;"], topNav.mobile.animationAxis);
}, function (_ref27) {
  var open = _ref27.open,
    theme = _ref27.theme;
  return open ? theme.elevation.xl : 'none';
});
exports.ModalContainer = ModalContainer;
var StyledExpander = (0, _styledComponents.default)(_expander.default).withConfig({
  displayName: "MobileNavstyle__StyledExpander",
  componentId: "sc-1pplbpw-8"
})(["button{", ";", ";", "}"], navItemStyle, navItemPadding, (0, _styledComponentsRtl.default)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      padding-right: 0;\n    "]))));
exports.StyledExpander = StyledExpander;
var MobileSubLinks = _styledComponents.default.ul.withConfig({
  displayName: "MobileNavstyle__MobileSubLinks",
  componentId: "sc-1pplbpw-9"
})(["background-color:", ";box-shadow:inset ", ";"], function (_ref28) {
  var theme = _ref28.theme;
  return theme.topNav.mobile.subItemBackgroundColor;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.elevation.xs;
});
exports.MobileSubLinks = MobileSubLinks;
var Line = _styledComponents.default.span.withConfig({
  displayName: "MobileNavstyle__Line",
  componentId: "sc-1pplbpw-10"
})(["width:24px;height:2px;margin:5px auto;background-color:", ";display:block;transition:", ";", ";"], function (_ref30) {
  var theme = _ref30.theme;
  return theme.topNav.mobile.hamburgerMenuColor;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.animation.transitionSlow;
}, function (_ref32) {
  var open = _ref32.open;
  return open && (0, _styledComponents.css)(["&:nth-child(2){opacity:0;}&:nth-child(1){transform:translateY(7px) rotate(45deg);}&:nth-child(3){transform:translateY(-7px) rotate(-45deg);}"]);
});
exports.Line = Line;
var Actions = _styledComponents.default.div.withConfig({
  displayName: "MobileNavstyle__Actions",
  componentId: "sc-1pplbpw-11"
})(["display:flex;align-items:center;", ""], (0, _styledComponentsRtl.default)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    margin-right: -", ";\n  "])), function (_ref33) {
  var theme = _ref33.theme;
  return theme.space.xs;
})); //Mobile Nav JS disable

exports.Actions = Actions;
var ControlNav = _styledComponents.default.nav.withConfig({
  displayName: "MobileNavstyle__ControlNav",
  componentId: "sc-1pplbpw-12"
})(["padding:", ";", " outline:none;&::after{font-family:inherit;box-sizing:inherit;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent;}"], function (_ref34) {
  var theme = _ref34.theme;
  return theme.space.md;
}, (0, _styledComponentsRtl.default)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    margin-right: ", ";\n  "])), function (_ref35) {
  var theme = _ref35.theme;
  return theme.space.md;
}));
exports.ControlNav = ControlNav;
var Input = _styledComponents.default.input.withConfig({
  displayName: "MobileNavstyle__Input",
  componentId: "sc-1pplbpw-13"
})(["position:absolute;opacity:0;transform:translateX(-50%) translateY(-50%);padding:", ";height:1px;width:1px;top:45%;cursor:pointer;", " z-index:100;&:checked ~ ", "{opacity:1;visibility:visible;transform:translateY(0);cursor:pointer;pointer-events:auto;z-index:-1;}&:checked ~ ", "{&:nth-child(2){transform:translateY(7px) rotate(45deg);}&:nth-child(3){opacity:0;}&:nth-child(4){transform:translateY(-7px) rotate(-45deg);}}"], function (_ref36) {
  var theme = _ref36.theme;
  return theme.space.md;
}, (0, _styledComponentsRtl.default)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    margin-left: ", ";\n  "])), function (_ref37) {
  var theme = _ref37.theme;
  return theme.space.sm;
}), ModalContainer, Line);
exports.Input = Input;
var SecondaryLinksWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileNavstyle__SecondaryLinksWrapper",
  componentId: "sc-1pplbpw-14"
})(["border-top:1px solid ", ";margin-top:", ";padding:", " 0;"], function (_ref38) {
  var theme = _ref38.theme;
  return theme.colors.ui03;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.space.md;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.space.md;
});
exports.SecondaryLinksWrapper = SecondaryLinksWrapper;